import {useEffect} from "react";
import {breadcrumb} from "../utils/sentry";

export const useHandleVisibility = () => {
    // This hook just collecting statistics about visibility changes

    useEffect(() => {
        const handleVisibilityChange = () => {
            console.info('[useHandleVisibility] Visibility: ', document.visibilityState);
            breadcrumb('useHandleVisibility', 'Visibility', {visibilityState: document.visibilityState});
        };

        const handlePageshow = (e: any) => {
            console.info('[useHandleVisibility] Pageshow', e);
            breadcrumb('useHandleVisibility', 'Pageshow', {event: e});
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('pageshow', handlePageshow, true);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('pageshow', handlePageshow, true);
        };
    }, []);
};
